// extracted by mini-css-extract-plugin
module.exports = {"welcome":"text-block_welcome__11C7q"};